import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a trip distance icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TripDistanceIcon width={12} />
 */
const TripDistanceIcon = props => (
    <SvgIcon {...props}>
        <path d="M16.9925 3C14.2339 3 11.995 5.24 11.995 8C11.995 11.12 16.2629 15.07 16.2629 15.07C16.6627 15.44 17.3223 15.44 17.7321 15.07C17.7321 15.07 22 11.12 22 8C21.99 5.24 19.7511 3 16.9925 3ZM16.9925 9.25C16.3028 9.25 15.7431 8.69 15.7431 8C15.7431 7.31 16.3028 6.75 16.9925 6.75C17.6822 6.75 18.2419 7.31 18.2419 8C18.2419 8.69 17.6822 9.25 16.9925 9.25ZM5.998 5.55C3.78911 5.55 2 7.34 2 9.55C2 12.05 5.26837 15.07 5.26837 15.07C5.46827 15.26 5.73813 15.35 5.998 15.35C6.25787 15.35 6.52774 15.26 6.72764 15.07C6.72764 15.07 9.996 12.05 9.996 9.55C9.996 7.34 8.2069 5.55 5.998 5.55ZM6.05797 14.34C6.04798 14.34 6.02799 14.35 5.998 14.35C5.96802 14.35 5.94803 14.34 5.94803 14.34C5.12844 13.58 2.9995 11.23 2.9995 9.55C2.9995 7.9 4.34883 6.55 5.998 6.55C7.64718 6.55 8.9965 7.9 8.9965 9.55C8.9965 11.23 6.86757 13.58 6.05797 14.34ZM6.9975 9.55C6.9975 10.1 6.54773 10.55 5.998 10.55C5.44828 10.55 4.9985 10.1 4.9985 9.55C4.9985 9 5.44828 8.55 5.998 8.55C6.54773 8.55 6.9975 9 6.9975 9.55ZM18.4918 19.5C18.4918 20.33 17.8221 21 16.9925 21C16.3428 21 15.7931 20.58 15.5832 20H7.4073C7.1974 20.58 6.64768 21 5.998 21C5.16842 21 4.49875 20.33 4.49875 19.5C4.49875 18.67 5.16842 18 5.998 18C6.64768 18 7.1974 18.42 7.4073 19H15.5832C15.7931 18.42 16.3428 18 16.9925 18C17.8221 18 18.4918 18.67 18.4918 19.5Z" />
    </SvgIcon>
)

TripDistanceIcon.defaultProps = defaultProps

export { TripDistanceIcon }
